module.exports = __webpack_public_path__ + "static/media/capture.96e84aaa.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/gifshop/capture.mp4
// module id = 237
// module chunks = 0